import React from 'react'
import { useNode } from 'react-pagebuilder/hooks/useNode'
import { useEditor } from 'react-pagebuilder/hooks/useEditor'
import { ApplicazioneCard as Original } from 'components/molecules'
import {
  ApplicazioneCardFloatingSettings,
  ApplicazioneCardSettings,
} from './ApplicazioneCardSettings'
import { withBlock } from '../withBlock'
import { withCraft } from '../withCraft'
import {
  imageDefaultProps,
  imageItemParams,
} from 'react-pagebuilder/editor/Viewport/Sidebar/Toolbar/ImageToolbarSection'
import { getTextEditor } from '../TextEditor'
import { getAncestorNodeByName } from 'react-pagebuilder/utils/node'

export const defaultProps = {
  ...imageDefaultProps(),
}

export const applicazioneCardItemParams = (enabled, id, blockProps, children) => ({
  ...imageItemParams(blockProps),
  pk: id,
  name: getTextEditor(children?.[0], enabled),
  description: getTextEditor(children?.[1], enabled),
})

export const dynamicProps = []

export const ApplicazioneCard: any = withBlock(
  (props) => {
    const blockProps = {
      ...defaultProps,
      ...props.block,
    }

    const { children } = props

    const _ = props.renderValue

    const {
      id,
      connectors: { connect },
      selected,
      hovered,
      actions: { setProp, setCustom },
      customs,
    } = useNode(
      (state) => ({
        selected: state.events.selected,
        dragged: state.events.dragged,
        hovered: state.events.hovered,
        customs: state.data.custom,
      }),
      props
    )

    const { enabled, parentBlock } = useEditor(
      (state, query) => ({
        enabled: state.options.enabled,
        parentBlock: getAncestorNodeByName(id, query, 'ApplicationsSwiper')?.data?.props?.block,
      }),
      props
    )

    return (
      <div
        ref={(ref) => props.retRef(ref)}
        className={`block-applicazione-card ${props.className}`}
      >
        <Original
          item={applicazioneCardItemParams(enabled, id, blockProps, children)}
          editMode={enabled}
        />
      </div>
    )
  },
  defaultProps,
  dynamicProps
)

ApplicazioneCard.craft = withCraft({
  name: 'ApplicazioneCard',
  defaultProps: defaultProps,
  settings: ApplicazioneCardSettings,
  floatingSettings: ApplicazioneCardFloatingSettings,
})
